"use client"

import React, {FormEvent, useState} from 'react';
import styles from "./LoginForm.module.css";
import {loginRequest, setUserInStorage} from "@/utils/api/Login";
import {useAppStore} from "@/store/AppStore";
import {AiFillCloseCircle} from "react-icons/ai";
import {useTranslations} from "use-intl";
import {FaRegUserCircle} from "react-icons/fa";
import TextField from "@mui/material/TextField";
import {Avatar, Button} from "@mui/material";
import {useAvatarUrl} from "@/utils/hooks/useAvatarUrl";
import {Link, useRouter} from "@/i18n/routing";


export default function LoginForm() {
  const user = useAppStore((state) => state.user);
  const setOpen = useAppStore((state) => state.setLoginPopup);
  const open = useAppStore((state) => state.loginPopup);
  const setUser = useAppStore((state) => state.setUser);
  const router = useRouter()
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("")
  const [error, setError] = useState(false)
  const [errorMessage, setErrorMessage] = useState<string | undefined>("")
  const avatarUrl = useAvatarUrl(user?.email)
  const t = useTranslations('Main')

  const handleSubmit = async (e: FormEvent<HTMLFormElement>): Promise<void> => {
    e.preventDefault();
    const login = await loginRequest({email, password});
    if (!login) {
      setError(true)
      return
    }
    if ("message" in login) {
      setError(true)
      setErrorMessage(login.message)
    } else {
      setUser(login)
      setUserInStorage(login)
      setOpen(false)
    }
  }

  return (
    <div>
      <div onClick={() => {
        if (user) {
          router.push(`/account`)
        } else {
          setOpen(!open)
        }
      }} className={styles.wrapper}>
        {!user && <FaRegUserCircle size={24}/>}
        {user && <Avatar sx={{width: 24, height: 24}} src={avatarUrl}/>}
      </div>
      {open &&
          <div className={styles.backdrop}>
            <AiFillCloseCircle className={styles.close} size={30} onClick={() => {
              setOpen(!open)
            }}/>
            <form className={styles.form} onSubmit={(e) => {
              handleSubmit(e)
            }}>
              <h3 className={styles.title}>{t("loginTitle")}<FaRegUserCircle size={24}/></h3>
              {error && <div className={styles.error}>{errorMessage}</div>}
              <TextField required className={styles.input} onChange={(e) => {
                setEmail(e.target.value)
              }} type={'email'} autoComplete={'off'} placeholder={t("email")}/>
              <TextField required className={styles.input} onChange={(e) => {
                setPassword(e.target.value)
              }} type={'password'} autoComplete={'off'} placeholder={t("password")}/>
              <Button type={"submit"} className={styles.submit} color={"secondary"}
                      variant={'contained'}>{t("login")}</Button>
              <div className={styles.bottomLinks}>
                <Link onClick={() => {
                  setOpen(false)
                }} className={styles.bottomLink}
                      href={`/register`}>{t('notRegisteredYet')}
                </Link>
                <Link onClick={() => {
                  setOpen(false)
                }} className={styles.bottomLink}
                      href={`/password-reset`}>{t('passwordReset')}
                </Link>
                <Link onClick={() => {
                  setOpen(false)
                }}
                      className={styles.bottomLink}
                      href={`/verify`}>{t('notVerifiedYet')}</Link>
              </div>
            </form>
          </div>}
    </div>

  )
}
